import React, { Fragment, useState, useEffect, useContext, useRef } from "react";
import Input from "../components/yourdetails/inputs/Input";
import { InputDataContext } from "../shared/contexts/InputDataContext";
import CalculateButton from "../components/yourdetails/CalculateButtonRedundancy";
import { formatDateObject, moveDateByYears, setToStartOfDay } from "../utilities/Formatters";
import {getCookie, setCookie} from "../shared/utilities/Cookies"
import GenericButton from "../components/general/buttons/MinorButton";

import classes from "./2-YourDetailsRedundancy.module.css";

function YourDetailsPage() {

  const { inputsRef, initialInputs, initialValid, validRef, noCookieRef, forbidCookieRef} = useContext(InputDataContext);

  const [inputs, setInputs] = useState(inputsRef.current)
  const [valid, setValid] = useState(validRef.current)

  useEffect(() => {
    if(!forbidCookieRef.current) {
      // Save inputs to a cookie whenever it changes
      const inputsJSON = JSON.stringify(inputs);
      setCookie("inputs", inputsJSON, 1); 
      setCookie("valids", JSON.stringify(valid), 1)
    }
  }, [inputs]);


  const smoothScroll = (distance, duration) => {
    const startPosition = window.scrollY;
    const targetPosition = startPosition + distance; // This should be the final vertical position after scrolling

    let startTime = null;

    const ease = (t, b, c, d) => {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
    };

    const animation = currentTime => {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const run = ease(timeElapsed, startPosition, targetPosition - startPosition, duration); // Using targetPosition - startPosition as delta
        window.scrollTo(0, run);
        if (timeElapsed < duration) requestAnimationFrame(animation);
    };

    requestAnimationFrame(animation);
};

  useEffect(
    () => setValid((prev) => ({...prev, redDirected: inputs.redDirected === 'No'})), 
    [inputs.redDirected]
  )

  function Autofill() {
    setInputs(prev => ({
      ...prev,
      redDirected : 'Yes', 
      severancePayment : 50000,
      LumpSum : 0
      }
    ));

    setValid({
      ...valid,
      redDirected : true,
      severancePayment: true,
      LumpSum : true
    })
  }

  function resetCookies() {
    setCookie('inputs', '', -1); // Set cookie expiration to past date to delete
    setCookie('valid', '', -1);
    setInputs(prev => ({
  ...prev,
  ...initialInputs}));
    setValid(initialValid)
    noCookieRef.current = true
  }

  
  useEffect(
    () => {
      inputsRef.current = {
        ...inputsRef.current,
        ...inputs,
      };
    },
       [inputs]
  );

  useEffect(
    () => {validRef.current = valid}, [valid]
  )

  const show_autofill_development = true
  const show_autofill = show_autofill_development && (window.HOST_URL.includes("gad-hosting") || window.HOST_URL.includes("localhost")) && window.show_autofill

  return (
    <div>

      <h2>Tell us about your redundancy information</h2>
      
      <p>
        Please answer the following questions to allow us to provide you with an
        illustration of your redundancy benefits.
      </p>

      {show_autofill && <button onClick = {Autofill}> 

        Autofill
      </button>}

      {!noCookieRef.current && 
      <div className = {classes.cookie_container}> 
        <h2> We saved your inputs from before </h2>
        <p> We have saved the inputs you provided on a previous visit to this page.
        You can overwrite these by clicking 'reset cookies' </p>
      <GenericButton onClick= {resetCookies}>  reset cookies </GenericButton>
      
      </div>
      }

      <Input
        input={"redDirected"}
        inputType={"select"}
        options={["Yes", "No"]}
        text={`Have you been directed to the redundancy illustrator by your employer after being 
          provided with a severance payment value?`}
        help={null}
        inputs = {inputs}
        setInputs = {setInputs}
        valid = {valid}
        setValid = {setValid}
        invisible = {false}
      />
      {inputs.redDirected === "No" && (
        <div className={classes.input_container}>
          <p>
          To use the redundancy illustrator you need to have been directed to this illustrator from your 
          employer after being provided with a severance payment value. 
          Please go back to the "Detailed Results" tab to review your illustration that does not relate to redundancy.
          </p>
        </div>
      )}

        <Input
          input={"severancePayment"}
          inputs = {inputs}
          setInputs = {setInputs}
          valid = {valid}
          setValid = {setValid}
          inputType={"pretty"}
          label = {'Severance payment'}
          text={"Please provide the severance payment value provided by your employer."}
          minValue={1}
          maxValue={1000000}
          minValErrorMsg={"The value you've entered is too low."}
          maxValErrorMsg={"The value you've entered is too high."}
          invisible = {
            !((inputs.redDirected === "Yes")
            )
          }
        // />
        // <Input
        //   input={"LumpSum"}
        //   inputs = {inputs}
        //   setInputs = {setInputs}
        //   valid = {valid}
        //   setValid = {setValid}
        //   inputType={"pretty"}
        //   // label = {'Current salary'}
        //   text={"Would you like to contribute anything towards the funding unreduced benefits?"}
        //   minValue={0}
        //   maxValue={1000000}
        //   minValErrorMsg={"The value you've entered is too low."}
        //   maxValErrorMsg={"The value you've entered is too high."}
        //   invisible = {
        //     !((inputs.redDirected === "Yes" && valid.severancePayment)
        //     )
        //   }
        />

        {/* <p>
        [PLACEHOLDER FOR AfC INPUT (WHETHER EMPLOYER OR MEMBER MEETS ADDITIONAL COST OF REDUNDANCY BENEFITS)]
        </p> */}

      {
      // inputs.redDirected === "Yes" && valid.severancePayment && valid.LumpSum ? (
      inputs.redDirected === "Yes" && valid.severancePayment ? (
        <div className={classes.button_container}>
          <CalculateButton />
        </div>
      ) : null}

      {inputs.redDirected === 'No'}
    </div>
  );
}

export default YourDetailsPage;